import Stack from '@mui/material/Stack'
import { LineChart } from '@mui/x-charts/LineChart'
import { Dayjs } from 'dayjs'
import ChartLoading from '@/components/charts/ChartLoading'

const margin = { right: 24 }

// Example data (must match the number of days)

// Helper: generate array of dates between start and end
function generateDateRange(start: Dayjs, end: Dayjs): string[] {
  const dates: string[] = []
  let current = start.startOf('day')

  while (current.isBefore(end) || current.isSame(end, 'day')) {
    dates.push(current.format('YYYY-MM-DD')) // 👈 format how you like
    current = current.add(1, 'day')
  }

  return dates
}

export default function LineCharts({
  startDate,
  endDate,
  chartData,
  loading,
}: {
  startDate: Dayjs
  endDate: Dayjs
  chartData: any[]
  loading?: boolean
}) {
  const xData = generateDateRange(startDate, endDate)

  if (loading || !chartData.length) return <ChartLoading height={400} />

  return (
    <Stack sx={{ width: '100%', height: 400 }}>
      <LineChart
        xAxis={[{ data: xData, scaleType: 'point' }]}
        series={chartData.map((s, i) => ({
          ...s,
          id: `series-${i}`,
          // @ts-ignore
          data: s.data.map((v: number, index: number) => v + i * 0.01), // small offset
          showPoints: true,
          connectNulls: true,
          strokeDasharray: i % 2 === 0 ? '4 2' : undefined,
        }))}
        margin={margin}
      />
    </Stack>
  )
}
